import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { Installation } from "@/model/data/Installation";

export class GetInstallationsWithoutLicensesResData extends ApiGenericResponse {
    installations: Installation[];
    totalInstallationsCount: number;
    paginatedTotalItems: number;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Installations) {
            this.installations = new Array<Installation>();
            obj.Installations.forEach((installation) => {
                let i = new Installation();
                i.parse(installation);
                this.installations.push(i);
            });
        }
        if (obj.TotalFilteredInstallationsCount != null && obj.TotalFilteredInstallationsCount != undefined) this.paginatedTotalItems = obj.TotalFilteredInstallationsCount;
        if (obj.TotalInstallationsCount != null && obj.TotalInstallationsCount != undefined) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
